<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},

  methods: {},
}
</script>

<template>
  <div class="tutorial">
    <h5 class="tutorial__head"> 1. 取得粉絲專頁編號 </h5>
    <div class="tutorial__row">
      <div class="tutorial__item" style="width: 100%">
        <div class="tutorial__title">
          <span class="tutorial__step">1</span>
          點擊下方連結或者複製此連結至瀏覽器貼上<br>
          <a target="_blank" href="https://business.facebook.com/latest/inbox/settings/messaging">https://business.facebook.com/latest/inbox/settings/messaging</a>
          <br><br>
          <span class="tutorial__step">2</span>
          複製粉絲專頁編號 於後台【商店設定/Facebook粉絲專頁編號】欄位中貼上<br>
          <a target="_blank" href="https://business.facebook.com/latest/inbox/settings/messaging">https://business.facebook.com/latest/inbox/settings/messaging</a>
        </div>
        <img src="~@assets/images/tutorial/fbCode_n1.png" alt="" />
      </div>
      <!-- <div class="tutorial__arrow">
        <BaseIcon name="arrow-right" />
      </div>
      <div class="tutorial__item" style="width: 50%">
        <div class="tutorial__title">
          <span class="tutorial__step">2</span>
          複製粉絲專頁編號 於後台【商店設定/Facebook粉絲專頁編號】欄位中貼上
        </div>
        <img src="~@assets/images/tutorial/fbCode_2.jpg" alt="" />
      </div> -->
    </div>
    <div class="tutorial__border"></div>
    <h5 class="tutorial__head"> 2. 於粉絲專頁中貼上網址 </h5>
    <div class="tutorial__row">
      <div class="tutorial__item" style="width: 100%">
        <div class="tutorial__title">
          <span class="tutorial__step">1</span>
          點擊下方連結或者複製此連結至瀏覽器貼上<br>
          <a target="_blank" href="https://business.facebook.com/latest/inbox/settings/messaging">https://business.facebook.com/latest/inbox/settings/messaging</a>
          <br><br>
          <span class="tutorial__step">2</span>
          點選【洽談外掛程式】分頁，於右方【設定你的洽談外掛程式】欄位中 填寫您的訂購頁網址（https://xxxxx.{{ $t('APP_NAME')}}.com/)，並按下右下角發佈鍵
        </div>
        <img src="~@assets/images/tutorial/fbCode_n2.png" alt="" />
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
</style>
